import React, { useState } from 'react';
import { Col } from 'reactstrap';
import InputComponent from '../InputComponent';
import { useTranslation } from 'react-i18next';

const Email = (props) => {
    const { t } = useTranslation();
    const [isValid, setIsValid] = useState(true);

    const onInputChanged = (e) => {
        const value = e.target.value;
        if (value) {
            const getEmailState = validateEmail(value);
            setIsValid(getEmailState);
        } else {
            setIsValid(true);
        }
        props.changed(value);
    };

    const validateEmail = (email) => {
        const emailRegex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegex.test(email);
    };

    const getPlaceholder = () => {
        let placeholder = props.placeholder || props.questionText || t('enterYourEmail');
        if (props.isMandate) return `${placeholder} *`;
        return placeholder;
    };

    return (
        <React.Fragment>
            {props.type === 124 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                    <InputComponent
                        id={props.answerInternalIdentifier}
                        name={props.questionId}
                        value={props.value}
                        type="email"
                        className={`input-default w-100 placeholder-${props?.displayPosition} ${props.isMandate ? 'mandatory' : ''}`}
                        placeholder={getPlaceholder()}
                        invalid={props.error?.[props.questionId] || !isValid}
                        onChange={onInputChanged}
                        disabled={props.disable}
                        onBlur={() => props.handleOnBlur(isValid, 'email')}
                    />
                </Col>
            ) : (
                <InputComponent
                    id={props.answerInternalIdentifier}
                    name={props.questionId}
                    value={props.value}
                    type="email"
                    className={`input-default w-100 placeholder-${props?.displayPosition}`}
                    placeholder={getPlaceholder()}
                    invalid={props.error?.[props.questionId] || !isValid}
                    onChange={onInputChanged}
                    disabled={props.disable}
                    onBlur={() => props.handleOnBlur(isValid, 'email')}
                />
            )}

            {!isValid && <p className="text-danger">{t('validEmail')}</p>}
        </React.Fragment>
    );
};

export default Email;
